<template>
	<div class="mapping-setup-info" :class="{ 'is-closed': isClosed, [utilClasses]: !showUtilClasses }">
		<InfoSection :isCloseable="false">
			<div class="info-title">Let users define their own data structure with a mapping block</div>
			<div class="info-content">
				You’re letting users connect their [app] account in setup. Since [app] has a flexible data structure where users define their own
				properies, data mapping needs to be different for every user. The mapping block lets users define their own mapping in setup.
			</div>
			<div class="info-title">How it works:</div>
			<ol class="info-content">
				<li>Map your data as you would normally</li>
				<li>You’ll be prompted to give your propery a generic name</li>
				<li>Users will map the generic name to their corresponding property</li>
			</ol>
			<div class="mt-3 mb-1 flex-space-between--center">
				<PrimaryButton @click="close()" small>Got it</PrimaryButton>
				<div class="info-content"><span class="link-style">Watch a tutorial</span> <SIcon name="play-video" /></div>
			</div>
		</InfoSection>
	</div>
</template>

<script>
import PrimaryButton from '@/components/atoms/buttons/PrimaryButton.vue';
import StorageService from '@/utils/storage-service';
const HAS_MAPPING_INFO_BEEN_DISPLAYED = 'HAS_MAPPING_INFO_BEEN_DISPLAYED';
const storage = StorageService.getStorage();

export default {
	name: 'MappingSetupInfo',
	props: {
		utilClasses: { type: String },
	},
	methods: {
		close() {
			this.isClosed = true;
			storage.setItem(HAS_MAPPING_INFO_BEEN_DISPLAYED, true);
		},
	},
	data() {
		return {
			isClosed: storage.getItem(HAS_MAPPING_INFO_BEEN_DISPLAYED),
			showUtilClasses: storage.getItem(HAS_MAPPING_INFO_BEEN_DISPLAYED),
		};
	},
	components: { PrimaryButton },
};
</script>

<style scoped lang="scss">
.mapping-setup-info {
	height: fit-content;
	max-height: 100%;

	.info-title {
		font-size: 13px;
		font-weight: 700;
	}
	.info-content {
		margin: 4px 0 8px 0;
		font-size: 12px;
	}

	.info-title,
	.info-content {
		color: var(--primary-font-color) !important;
	}

	&.is-closed {
		max-height: 0;
		overflow: hidden;
		transition: max-height 0.3s linear;
	}

	::v-deep(.v-btn) {
		font-size: 14px !important;
	}
}
</style>
